module.exports = __webpack_public_path__ + "img/certifier.a522e129.svg";